<button
  type="button"
  class="project-task-columns-button"
  [matMenuTriggerFor]="columnsMenu"
  [attr.aria-label]="'MyWork.Columns.show' | translate"
>
  <img src="./assets/img/eye-icon.svg" alt="" aria-hidden="true" />
</button>

<mat-menu #columnsMenu="matMenu" xPosition="before" class="menu-v2 project-task-columns-menu">
  <div class="project-task-columns-menu__list" (click)="$event.stopPropagation()">
    <div class="project-task-columns-menu__title">{{ 'MyWork.Columns.show' | translate }}</div>
    @for (column of columns.columns; track column) {
      <div class="form-control-checkbox project-task-columns-menu__option">
        <label class="m-0 d-flex align-items-center">
          <input type="checkbox" [checked]="columns.isVisible(column)" (change)="columns.toggle(column)" />
          <span></span>
          <span>{{ 'MyWork.Columns.' + column | translate }}</span>
        </label>
      </div>
    }
  </div>
</mat-menu>
